import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import axios from "axios";
import {BASE_URL} from "../contants/network";

export const getUploadUrl = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'uploads/url',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain
    });
}